<div id="cookie-manager-bar" *ngIf="showBar && !isOnApp">
  <div id="msg-cont">
    <div>
      <mat-icon color="primary">cookie</mat-icon>
    </div>
    <p>
      {{
        'Az oldal megfelelő működése érdekében sütiket használunk. A sütik segítenek a weboldal teljesítményének javításában, a felhasználói élmény fokozásában, és releváns hirdetések megjelenítésében.'
          | translate
      }}
    </p>
  </div>
  <div class="actions">
    <button mat-raised-button color="primary" (click)="acceptAll()">
      <mat-icon color="primary">check</mat-icon>
      {{ 'Elfogadom' | translate }}
    </button>
    <button mat-raised-button (click)="openDialog()">
      <mat-icon>tune</mat-icon>{{ 'Beállítások' | translate }}
    </button>
  </div>
</div>
<div
  id="cookie-manager-dialog"
  *ngIf="showDialog"
  (click)="cancelDialog()"
  tabindex="2"
  (keydown.enter)="cancelDialog()">
  <div
    id="cookie-manager-dialog-inner-cont"
    (click)="$event.stopPropagation()"
    tabindex="3"
    (keydown)="(0)">
    <h2>{{ 'Süti beállítások' | translate }}</h2>
    <p>
      {{
        'Itt testreszabhatja, hogy mely sütiket szeretné engedélyezni. Kérjük, válassza ki az Ön által kívánt beállításokat.'
          | translate
      }}
    </p>
    <div id="cookie-list" [formGroup]="cookieForm">
      <div>
        <div>
          <h3>{{ 'Szükséges sütik' | translate }}</h3>
          <p>
            {{
              'Ezek a sütik elengedhetetlenek az oldal megfelelő működéséhez, és nem kapcsolhatók ki. Általában csak az Ön által végrehajtott műveletekre adott válaszként kerülnek beállításra, mint például adatvédelmi beállítások megadása, bejelentkezés, vagy űrlapok kitöltése.'
                | translate
            }}
          </p>
        </div>
        <div><mat-slide-toggle checked disabled></mat-slide-toggle></div>
      </div>
      <div>
        <!-- <div>
          <h3>{{'Teljesítmény sütik' | translate}}</h3>
          <p>
            {{'Ezek a sütik lehetővé teszik számunkra, hogy számoljuk a látogatásokat és a forgalmi forrásokat, így mérhetjük és javíthatjuk webhelyünk teljesítményét. Minden általuk gyűjtött információ összesített és névtelen.' | translate}}
          </p>
        </div>
        <div><mat-slide-toggle formControlName="performanceCookie" checked></mat-slide-toggle></div>
      </div>
      <div>
        <div>
          <h3>{{'Funkcionális sütik' | translate}}</h3>
          <p>
            {{'Ezek a sütik lehetővé teszik a weboldal számára, hogy fokozott funkcionalitást és személyre szabást nyújtson. Lehet, hogy az általunk vagy harmadik fél szolgáltatók által kerülnek beállításra, akiknek szolgáltatásait az oldalon használjuk.' | translate}}
          </p>
        </div>
        <div><mat-slide-toggle formControlName="functionalCookie" checked></mat-slide-toggle></div>
      </div>
      <div>
        <div>
          <h3>{{'Célzó/marketing sütik' | translate}}</h3>
          <p>
            {{'Ezeket a sütiket hirdetési partnereink állíthatják be az oldalon, hogy releváns hirdetéseket jelenítsenek meg Önnek. Ezek a cégek felhasználhatják azokat az Ön érdeklődési körének profilozására, és más oldalakon releváns hirdetéseket jeleníthetnek meg.' | translate}}
          </p>
        </div>
        <div><mat-slide-toggle formControlName="marketingCookie" checked></mat-slide-toggle></div>
      </div> -->
        <div>
          <div>
            <h3>{{ 'Teljesítmény- és célzó/marketing sütik' | translate }}</h3>
            <strong>
              {{ 'Teljesítmény sütik' | translate }}:
            </strong>
            <p>
              {{
                'Ezek a sütik lehetővé teszik számunkra, hogy számoljuk a látogatásokat és a forgalmi forrásokat, így mérhetjük és javíthatjuk webhelyünk teljesítményét. Minden általuk gyűjtött információ összesített és névtelen.'
                  | translate
              }}
            </p>
            <div></div>
            <strong>
              {{ 'Célzó/marketing sütik' | translate }}:
            </strong>
            <p>
              {{
                'Ezeket a sütiket hirdetési partnereink állíthatják be az oldalon, hogy releváns hirdetéseket jelenítsenek meg Önnek. Ezek a cégek felhasználhatják azokat az Ön érdeklődési körének profilozására, és más oldalakon releváns hirdetéseket jeleníthetnek meg.'
                  | translate
              }}
            </p>
          </div>
        </div>
        <div>
          <mat-slide-toggle
            formControlName="performanceAndMarketingCookies"
            checked></mat-slide-toggle>
        </div>
      </div>
      <div class="actions">
        <button mat-fab extended color="primary" (click)="acceptPartial()">
          <mat-icon>check</mat-icon>
          {{ 'Mentés' | translate }}
        </button>
        <button mat-fab extended (click)="cancelDialog()">
          <mat-icon>close</mat-icon>{{ 'Bezárás' | translate }}
        </button>
      </div>
      <span
        id="close"
        (click)="cancelDialog()"
        tabindex="1"
        (keydown.escape)="cancelDialog()"
        ><mat-icon>close</mat-icon></span
      >
    </div>
  </div>
</div>
